import type { GetSiteResponse } from "@/client";
import { getParamOptions, getParamQueryKey, getSiteQueryKey } from "@/client/@tanstack/react-query.gen"
import { readCache } from "@/store/action"

const keys = [
  'startTime',
  'endTime',
  'missionStopAt',
  'phase',
  'doubleSpinDates',
  'serverAccSpinProgress',
  'tokensPerSpin',
  'predictUnitAmount',
  'predictMinAmount',
  'predictMaxAmount',
  'predictScorePayout',
  'rule',
  'title2',
  'des2',
  'title3',
  'des3',
  'title4',
  'des4',
  'title5',
  'des5',
  'title6',
  'des6',
  'title7',
  'des7',
  'title8',
  'des8',
  'title9',
  'des9',
  'defaultPhase',
  'kvVideo',
  'kvImage',
  'errors',
  'no_account_msg',
  'no_account_url',
  'accCodePlayDayDifference',
  'maxRival',
  'maxSendWish',
  'maxReceiveWish',
  'ruleLottery',
  'iconBoxLucky',
  'serverKvImage',
  'serverKvGrayImage',
  'randomPlayerRequiredSpins'
] as const;

type ParamKey = typeof keys[number];
type Params = Record<ParamKey, unknown>;

//Params
export const getParams = () => {
  return readCache<unknown, Params>(getParamQueryKey({
    query: {
      ids: keys as unknown as string[],
    }
  }))
}
export const useParamsOptions = () => {
  return getParamOptions({
    query: {
      ids: keys as unknown as string[],
    }
  })
}

//Site
export const getEventConfig = () => {
  return readCache<ReturnType<typeof getSiteQueryKey>, GetSiteResponse>(getSiteQueryKey())
}

// Alias dùng trong các section
export const getConfig = getEventConfig

